<template>
  <v-dialog v-model="openDialog" persistent width="500px">
    <v-card>
      <v-card-title class="pb-0">
        <span class="section-title">Bloqueio realizado com sucesso!</span> <br />
        <p class="subtitle ma-0" style="word-break: break-word">Confira as alterações realizadas:</p>
      </v-card-title>
      <v-card-text class="px-0">
        <v-row no-gutters class="pb-1">
          <v-col class="pl-6">
            <span class="link" @click="exportDocuments">Exportar documentos</span>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col class="pa-0">
            <v-data-table :items="items" :headers="headers" disable-filtering disable-pagination disable-sort hide-default-footer>
              <template v-slot:item="{ item }">
                <tr>
                  <td class="pl-6">{{ item.change }}</td>
                  <td class="pr-9 text-right">{{ item.quantity }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <mf-action-buttons
          :primary-button="{
            text: 'Fechar',
            action: closeDialog,
            isVisible: true,
          }"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { createCsvFromArray } from '@/config/helpers.js'

export default {
  name: 'BlockDocumentImportModal',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    importsArray: {
      type: Object,
      required: true,
    },
  },
  computed: {
    openDialog: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    headers() {
      return [
        {
          text: 'Alteração',
          value: 'change',
          align: 'left',
          class: 'pl-6',
        },
        {
          text: 'Quantidade de CPFs/CNPJs',
          value: 'quantity',
          align: 'right',
          class: 'pr-9',
        },
      ]
    },
    items() {
      const { alreadyBlocked, blockedNow, invalid } = this.importsArray

      return [
        { change: 'CPFs/CNPJs que foram bloqueados', quantity: blockedNow.length },
        { change: 'CPFs/CNPJs que já estavam bloqueados', quantity: alreadyBlocked.length },
        { change: 'CPFs/CNPJs incorretos', quantity: invalid.length },
      ]
    },
  },
  methods: {
    closeDialog() {
      this.openDialog = false
      this.$emit('return-page')
    },
    exportDocuments() {
      const importKeys = Object.keys(this.importsArray)
      const maxLength = Object.keys(this.importsArray).reduce((maxLengthArray, current, index) => {
        const previousLength = Object.keys(this.importsArray)[index - 1]?.length ?? 0

        if (this.importsArray[current].length > previousLength) {
          maxLengthArray = this.importsArray[current].length
        }

        return maxLengthArray
      }, 0)
      const exportArray = []

      for (let index = 0; index < maxLength; index++) {
        const formatted = {
          [importKeys[0]]: this.importsArray[importKeys[0]][index] ?? '',
          [importKeys[1]]: this.importsArray[importKeys[1]][index] ?? '',
          [importKeys[2]]: this.importsArray[importKeys[2]][index] ?? '',
        }

        exportArray.push(formatted)
      }

      createCsvFromArray(exportArray, 'documentos', ['CPFs/CNPJs que não foram bloqueados', 'CPFs/CNPJs que foram bloqueados', 'CPFs/CNPJs incorretos'])
    },
  },
}
</script>

<style lang="scss">
.max-section {
  max-height: 300px;
}
.scroll-selection {
  overflow: auto;
}
.light-background {
  background-color: $cinza-l90;
}
</style>
